import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CARD_SHADOW, CARD_SHADOWS } from './constants';

const Card = ({ children, className = '', shadow = CARD_SHADOW.LG, ...rest }) => (
    <div
        className={classNames('ds-card', `ds-card--shadow-${shadow}`, className)}
        {...rest}
    >
        {children}
    </div>
);

Card.propTypes = {
    /** Card content */
    children: PropTypes.node,
    /** Extra classes appended to the card element */
    className: PropTypes.string,
    /** Elevation of the card surface */
    shadow: PropTypes.oneOf(CARD_SHADOWS),
};

export { CARD_SHADOW, CARD_SHADOWS };
export default Card;
